import { keyframes } from 'styled-components';
import { AnimationEntryExit } from '../../Overlays/types';

export const animationRotate = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;

export const animationBounce = keyframes`
    {
        0% {
            transform: translateY(0px);
        }

        40% {
            transform: translateY(-24px);
        }

        60% {
            transform: translateY(12px);
        }

        80% {
            transform: translateY(0px);
        }
    }
`;

export const animationSlideFromButton = (animateStyle: AnimationEntryExit) => keyframes`
{   
        ${
            animateStyle === AnimationEntryExit.EXIT
                ? ` 
                from {
                    margin-top: 0%;  
                } 
                to {
                    margin-top: 100vh;
                }


       `
                : `      from {
                    margin-top: 100%;
                     height: 300%; 
                } 
                to {
                margin-top: 0%;
                height: 100%;
                }
      
          `
        }
}
`;
